module.exports = __webpack_public_path__ + "img/x.150a8d7a.svg";